/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Role } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface UserRolesServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get all Roles of the user by Username
     * Returns all Roles of the user with the specified username.
     * @param username The username of the user
     */
    getUserRolesByUsername(username: string, extraHttpRequestParams?: any): Observable<Array<Role>>;

    /**
     * Update roles of the user
     * Update the roles of the user with the specified username. Will delete all other user roles!
     * @param username The username of the user to update.
     * @param requestBody List of role ids
     */
    updateUserRolesByUsername(username: string, requestBody: Array<number>, extraHttpRequestParams?: any): Observable<{}>;

}
